import { useState, useEffect } from 'react';
import { SendMessage, socket } from './App.js';
import iconextsong from './img/ico-nextsong.svg';
import iconextsongDisabled from './img/ico-nextsongDisabled.svg';
import iconextsongRed from './img/ico-nextsongRed.svg';

import icoreplay from './img/ico-replay.svg';
import icoreplayDisabled from './img/ico-replayDisabled.svg';
import icoreplayRed from './img/ico-replayRed.svg';

import icoclosewhite from './img/ico-closeWhite.svg';

import icopause from './img/ico-pause.svg';
import icopauseDisabled from './img/ico-pauseDisabled.svg';
import icopauseRed from './img/ico-pauseRed.svg';

import icodel from './img/ico-del.svg';
import icodelblue from './img/ico-delBlue.svg';
import icodelRed from './img/ico-delRed.svg';

import icovol from './img/ico-vol.svg';
import icovolDisabled from './img/ico-volDisabled.svg';
import icovolWhite from './img/ico-volWhite.svg';

import icoecho from './img/ico-echo.svg';
import icoechoDisabled from './img/ico-echoDisabled.svg';
import icoechoWhite from './img/ico-echoWhite.svg';

import icomic from './img/ico-mic.svg';
import icomicDisabled from './img/ico-micDisabled.svg';
import icomicWhite from './img/ico-micWhite.svg';

import strings from './strings.js';

const API_URL = "https://www.starboxkod.com/api";

const SelectingControlCard = ({ stateVer, statePlaybackUserId, onClick, tableNo, lang, stateDuration, hasReplayed, setHasReplayed, micEnabled }) => {

    const song = {
        "song_num": 110108,
        "song_name": "给我多一点",
        "singer": "SHE",
        "language": "国语",
        "server_id": "C",
        "rel_path": "05\\110108"
    };
    
    const [controlsEnabled, setControlsEnabled] = useState(
        statePlaybackUserId === JSON.parse(localStorage.getItem("sn")) || statePlaybackUserId === "50"
    );

    useEffect(() => {
        setControlsEnabled(
            statePlaybackUserId === JSON.parse(localStorage.getItem("sn")) || statePlaybackUserId === "50"
        );
    }, [statePlaybackUserId]);

    const isSkinOne = document.body.getAttribute('data-skin') === '1';
  
    return (
        <div className="LMAOselecting">
            <div className="mui-overlay" onClick={(e) => { e.preventDefault(); }}></div>
            
            <div className="actions-sheet2" onClick={(e) => { e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation(); }}>
                <div className="controlCardClose">
                    <a className="controlCardCloseIcon" onClick={(e) => { e.preventDefault(); onClick(); }}>
                        <img 
                            src={icoclosewhite}
                            alt="close"
                        />
                    </a>
                </div>
                <div className="bottom-buttons">
                    { !controlsEnabled && (
                        <div style={{ color: isSkinOne ? '#000000' : '#3751fe', fontWeight: "500", fontSize: "18.5px", textAlign: "center", marginBottom: "10px" }}>
                            {lang ? strings.cn.controlsDisabledMsg : strings.en.controlsDisabledMsg}
                        </div>
                    )}
                
                    { micEnabled && (
                        <>
                            <div style={{ color: controlsEnabled ? (isSkinOne ? '#000000' : '#3751fe') : "#7a7d7a", fontWeight: "500", fontSize: "18.5px", textAlign: "center" }}>
                                {lang ? strings.cn.micvol : strings.en.micvol}
                            </div>
                            <div className="add-song-container" style={{ marginBottom: "5px" }}>
                                <a className="ActionPanelnorec-btn"
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        if (controlsEnabled) { socket.emit("down-mic"); }
                                    }}
                                    style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a", marginLeft: "0px" }}
                                >
                                    ▼&#xFE0E;
                                </a>
                                <a className="ActionPanelmid-btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (controlsEnabled) { socket.emit("m1"); }
                                    }}
                                >
                                    <img 
                                        style={{ maxHeight: "55%", width: "auto" }}
                                        src={controlsEnabled ? (isSkinOne ? icomicWhite : icomic) : icomicDisabled}
                                        alt="mic"
                                    />
                                </a>    
                                <a className="ActionPanelrec-btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (controlsEnabled) { socket.emit("up-mic"); }
                                    }}
                                    style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a" }}
                                >
                                    ▲&#xFE0E;
                                </a>    
                            </div>

                            <div style={{ color: controlsEnabled ? (isSkinOne ? '#000000' : '#3751fe') : "#7a7d7a", fontWeight: "500", fontSize: "18.5px", textAlign: "center" }}>
                                {lang ? strings.cn.echo : strings.en.echo}
                            </div>
                            <div className="add-song-container" style={{ marginBottom: "5px" }}>
                                <a className="ActionPanelnorec-btn"
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        if (controlsEnabled) { socket.emit("down-echo"); }
                                    }}
                                    style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a", marginLeft: "0px" }}
                                >
                                    ▼&#xFE0E;
                                </a>
                                <a className="ActionPanelmid-btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (controlsEnabled) { socket.emit("m1"); }
                                    }}
                                >
                                    <img
                                        style={{ maxHeight: "55%", width: "auto" }}
                                        src={controlsEnabled ? (isSkinOne ? icoechoWhite : icoecho) : icoechoDisabled}
                                        alt="echo"
                                    />
                                </a>    
                                <a className="ActionPanelrec-btn"
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        if (controlsEnabled) { socket.emit("up-echo"); }
                                    }}
                                    style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a" }}
                                >
                                    ▲&#xFE0E;
                                </a>    
                            </div>
                        </>
                    )}

                    <div style={{ color: controlsEnabled ? (isSkinOne ? '#000000' : '#3751fe') : "#7a7d7a", fontWeight: "500", fontSize: "18.5px", textAlign: "center" }}>
                        {lang ? strings.cn.key : strings.en.key}
                    </div>
                    <div className="add-song-container" style={{ marginBottom: "5px" }}>
                        <a className="ActionPanelnorec-btn"
                            onClick={(e) => {
                                e.preventDefault(); 
                                if (controlsEnabled) { SendMessage(`[{"type":"DOWN_KEY"}]`); }
                            }}
                            style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a", marginLeft: "0px" }}
                        >
                            ▼&#xFE0E;
                        </a>
                        <a className="ActionPanelmid-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                if (controlsEnabled) { SendMessage(`[{"type":"NORMAL_KEY"}]`); }
                            }}
                            style={{ color: controlsEnabled ? (isSkinOne ? '#ffffff' : '#3751fe') : "#7a7d7a", fontSize: "35px" }}
                        >
                            ♮
                        </a>    
                        <a className="ActionPanelrec-btn"
                            onClick={(e) => {
                                e.preventDefault(); 
                                if (controlsEnabled) { SendMessage(`[{"type":"UP_KEY"}]`); }
                            }}
                            style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a" }}
                        >
                            ▲&#xFE0E;
                        </a>    
                    </div>

                    { (stateVer === "wangluo" || stateVer === "danji") && (
                        <>
                            <div style={{ color: controlsEnabled ? (isSkinOne ? '#000000' : '#3751fe') : "#7a7d7a", fontWeight: "500", fontSize: "18.5px", textAlign: "center" }}>
                                {lang ? strings.cn.musicvol : strings.en.musicvol}
                            </div>
                            <div className="add-song-container" style={{ marginBottom: "5px" }}>
                                <a className="ActionPanelnorec-btn"
                                    onClick={(e) => {
                                        if (controlsEnabled) { SendMessage(`[{"type":"DOWN_VOL"}]`); }
                                    }}
                                    style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a", marginLeft: "0px" }}
                                >
                                    ▼&#xFE0E;
                                </a>
                                <div className="ActionPanelmid-btn"
                                    onClick={(e) => {
                                        if (controlsEnabled) { SendMessage(`[{"type":"MUTE_VOL"}]`); }
                                    }}>
                                    <img className="ControlCardImg" 
                                        src={controlsEnabled ? (isSkinOne ? icovolWhite : icovol) : icovolDisabled} 
                                        alt="vol"
                                        style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, height: "25px", maxWidth: 10000000000 }}
                                    />                                  
                                </div>    
                                <a className="ActionPanelrec-btn"
                                    onClick={(e) => {
                                        if (controlsEnabled) { SendMessage(`[{"type":"UP_VOL"}]`); }                           
                                    }}
                                    style={{ color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a" }}
                                >
                                    ▲&#xFE0E;
                                </a> 
                            </div>
                        </>
                    )}
                    
                    {/* 1:1 Matching Vocal Toggles (Both White in one pill) */}
                    <div style={{
                        display: "flex",
                        border: `1px solid ${controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a"}`,
                        borderRadius: "30px",
                        //width: "75%",
                        //margin: "15px auto 5px auto",
                        marginTop: "15px",
                        marginBottom: "5px",
                        marginLeft: "20px",
                        marginRight: "20px",
                        backgroundColor: "#fff",
                        overflow: "hidden"
                    }}>
                        <a 
                            onClick={(e) => {
                                e.preventDefault();
                                if (controlsEnabled) { SendMessage(`[{"type":"BC_VOCAL"}]`); }
                            }}
                            style={{
                                flex: 1, 
                                padding: "8px 0",
                                textAlign: "center",
                                textDecoration: "none",
                                color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a",
                                borderRight: `1px solid ${controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a"}`,
                                fontWeight: "500", 
                                fontSize: "18.5px"
                            }}
                        >
                            {lang ? strings.cn.acc : strings.en.acc}
                        </a>
                        <a 
                            onClick={(e) => {
                                e.preventDefault();
                                if (controlsEnabled) { SendMessage(`[{"type":"YC_VOCAL"}]`); }
                            }}
                            style={{
                                flex: 1,
                                padding: "8px 0",
                                textAlign: "center",
                                textDecoration: "none",
                                color: controlsEnabled ? (isSkinOne ? '#ff5b00' : '#3751fe') : "#7a7d7a",
                                fontWeight: "500", 
                                fontSize: "18.5px"
                            }}
                        >
                            {lang ? strings.cn.ori : strings.en.ori}
                        </a>    
                    </div>
                </div>

                <div className="controlCardBottom">
                    {(stateVer === "wangluo" || stateVer === "danji") && (
                        <>
                            <div className="controlCardButton"
                                style={{ borderColor: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (controlsEnabled) { SendMessage(`[{"type":"HALL_PAUSE_CURRENT"}]`); }                
                                }}
                            >
                                <img className="controlCardIcon"
                                    src={controlsEnabled ? (isSkinOne ? icopauseRed : icopause) : icopauseDisabled}
                                    alt="pause"
                                />
                                <div className="controlCardText" style={{ color: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}>
                                    {lang ? strings.cn.playpause : strings.en.playpause}
                                </div>
                            </div>
                        </>
                    )}

                    <div className="controlCardButton"
                        style={{ borderColor: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}
                        onClick={(e) => {
                            if (controlsEnabled) {
                                if (stateVer === "danji") {
                                    SendMessage(`[{"type":"HALL_REPLAY_FORCE"}]`);
                                }
                                else if (stateVer === "wangluo") {
                                    SendMessage(`[{"type":"HALL_REPLAY_CURRENT"}]`);
                                }   
                                else {
                                    if (!isNaN(stateDuration)) {
                                        if (stateDuration < 20) {
                                            if (hasReplayed === false) {
                                                SendMessage(`[{"type":"HALL_REPLAY_FORCE"}]`);  
                                                setHasReplayed(true);
                                            }
                                        }
                                    } else {
                                        SendMessage(`[{"type":"HALL_REPLAY_CURRENT"}]`); 
                                    }
                                    onClick();
                                }
                            }                        
                        }}
                    >
                        <img className="controlCardIcon"
                            src={controlsEnabled ? (isSkinOne ? icoreplayRed : icoreplay) : icoreplayDisabled}
                            alt="replay"
                        />
                        <div className="controlCardText" style={{ color: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}>
                            {lang ? strings.cn.replay : strings.en.replay}
                        </div>
                    </div>

                    { stateVer === "dating"  && (
                        <>
                            <div className="controlCardButton"
                                style={{ borderColor: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (controlsEnabled) {
                                        if (!isNaN(stateDuration)) {
                                            if (stateDuration < 20) {
                                                SendMessage(`[{"type":"HALL_DISCARD_FORCE"}]`);  
                                            }
                                        } else {
                                            SendMessage(`[{"type":"HALL_DISCARD_CURRENT"}]`); 
                                        }
                                        onClick();
                                    }
                                }}
                            >
                                <img className="controlCardIcon"
                                    src={controlsEnabled ? (isSkinOne ? icodelRed : icodelblue) : icodel}
                                    alt="discard"
                                />
                                <div className="controlCardText" style={{ color: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}>
                                    {lang ? strings.cn.discard : strings.en.discard}
                                </div>
                            </div>
                        </>
                    )}

                    <div className="controlCardButton"
                        style={{ borderColor: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}
                        onClick={(e) => {
                            e.preventDefault();
                            if (controlsEnabled) {
                                SendMessage(`[{"type":"HALL_STOP_CURRENT"}]`);
                                if (stateVer === "dating") {
                                    onClick();
                                }
                            }
                        }}
                    >
                        <img className="controlCardIcon"
                            src={controlsEnabled ? (isSkinOne ? iconextsongRed : iconextsong) : iconextsongDisabled}
                            alt="nextsong"
                        />
                        <div className="controlCardText" style={{ color: controlsEnabled ? (isSkinOne ? '#d2332f' : '#5c6aff') : "#7a7d7a" }}>
                            {lang ? strings.cn.next : strings.en.next}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SelectingControlCard;